import { render, staticRenderFns } from "./average-throughput.vue?vue&type=template&id=2e6109fe"
import script from "./average-throughput.vue?vue&type=script&lang=js"
export * from "./average-throughput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports